import { gql, useLazyQuery, useMutation, useQuery } from '@apollo/client'
import { useState, useEffect } from 'react'
import Select, { ActionMeta, components } from "react-select";
import { Flex, Box, Text, Card, Button, Heading } from 'rebass/styled-components'
import styled from 'styled-components'
import Modal from 'styled-react-modal'
import { Skeleton } from '../../components/loadingSkeleton/Skeleton'
import { GET_CUSTOM_ASSIGNED_PRESET_PLANS, GET_PAID_MOBILE_COURSE_HC, GET_PATIENT_MOBILE_COURSES, GET_PRESET_PLANS, GET_THYROID_PROGRAM_SUMMARY } from '../../graphql/queries'
import { IGetPatientMobileCoursesInput, IGetPatientMobileCoursesOutput, IHealthCoachGetPaidMobileCourseHcInput, IHealthCoachGetPaidMobileCourseHcOutput } from '../../graphql/types/queries/course'
import { IGetCustomAssignedPresetPlansInput, IGetCustomAssignedPresetPlansOutput, IGetPresetPlanSummaryInput, IGetPresetPlanSummaryOutput, IGetPresetPlansInput, IGetPresetPlansOutput, IPresetPlanSummary } from '../../graphql/types/queries/presetPlans'
import { parseStringify } from '../../utils/StringUtils'
import { ReactSelectStyles } from '../../styles/ReactSelectStyles';
import { RbCircledChecked, RbCircledUnchecked } from '../../components/RadioButton';
import { SpecialModalBackground } from '../../components/Commons';
import PleaseWait from '../../components/PleaseWait';
import { weeksSummary } from './components/weeksSummary';
import { Weeker } from './components/Weeker';
import { DetailsCoursesProgressAip } from './components/DetailsCoursesProgressAip';
import { DetailsProgramProgress } from './components/DetailsProgramProgress';
import { PresetPlan } from './components/PresetPlan';
import { AssignCustomPresetPlans } from './components/AssignCustomPresetPlans';
import moment from 'moment';
import { CourseEngagementChart } from './components/CourseEngagementChart';
import { EnhancedModal } from '../../components/EnhancedModal';
import { Link } from 'react-router-dom';
import { IOkPayload } from '../../graphql/types/mutations/generics';
import { toast } from 'react-toastify';
import { ShowVisits } from './components/ShowVisits';


interface IHealthCoachOfferHcCourseOutput {
  healthCoachOfferHcCourse: IOkPayload
}

interface IHealthCoachOfferHcCourseInput {
  patientId: string
  courseId: string
}

interface IHealthCoachRemoveHcCourseOutput {
  healthCoachRemoveHcCourse: IOkPayload
}

interface IHealthCoachRemoveHcCourseInput {
  patientId: string
  courseId: string
}

const OFFER_MOBILE_COURSE_HC = gql`
  mutation healthCoachOfferHcCourse($patientId: String!, $courseId: String!) {
    healthCoachOfferHcCourse(patientId: $patientId, courseId: $courseId) {
      ok
    }
  }
`;

const REMOVE_MOBILE_COURSE_HC = gql`
  mutation healthCoachRemoveHcCourse($patientId: String!, $courseId: String!) {
    healthCoachRemoveHcCourse(patientId: $patientId, courseId: $courseId) {
      ok
    }
  }
`;

const Wrapper = styled(Flex)`
  overflow: auto;
  width: 800px;
  padding-right: 20px;
  margin-right: 20px;
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  &::-webkit-scrollbar-thumb {
    background: #6c89b7;
    border-radius: 5px;
  }
  &::-webkit-scrollbar {
    width: 7px;
    border: 1px solid transparent;
  }
`;

export const HoverableCard = styled(Card)`
  transition:all 0.3s ease;
  flex: initial;
  cursor: ${props => (props.onClick ? 'pointer' : '')};
`

export const ListContainer = styled(Flex)`
  min-width: min(300px, 100vw);
  padding-right: 12px;
  overflow-y: auto;
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  &::-webkit-scrollbar-thumb {
    background: #6c89b7;
    border-radius: 5px;
  }
  &::-webkit-scrollbar {
    width: 7px;
    border: 1px solid transparent;
  }
  
  &.selected {
    display: none;
  }

  @media screen and (min-width: 68.8125em) {
    width: auto;
    &.selected {
      display: flex;
    }
  }
`;

interface ILastCoursesProps {
  id: string
  isMinimized?: boolean
  isMobileUser?: boolean
}

const CourseRowLoading = () => {
  return (
    <HoverableCard mb={2}
      style={{
        opacity: 1,
        boxShadow: '0px 4px 20px rgb(0 0 0 / 10%)'
      }}>
      <Flex style={{ width: '100%', padding: '18px 12px' }} flexDirection='column'>
        <Text style={{ color: 'rgba(52,79,122,0.6)', fontSize: '12px' }}><Skeleton height={18} width={45} /></Text>
        <Text style={{ fontSize: '12px' }}><Skeleton height={21} width={140} /></Text>
      </Flex>
    </HoverableCard>
  )
}

export interface ISummary {
  weekNumber: number;
  complete: boolean;
  notStarted: boolean;
  journeyName: string;
  pct: number;
}

export interface IProgram {
  label: string;
  value: 'aipProgram' | string;

}

const Option = (props: any) => {
  return (
    <components.Option {...props}>
      <Flex alignItems={'center'}>
        {props.isSelected ? (
          <RbCircledChecked />
        ) : <RbCircledUnchecked />}

        <Text ml={2}>{props.children}</Text>
      </Flex>
    </components.Option>
  );
};

export const getSections = (secs: IPresetPlanSummary[] | undefined) => {
  if (!secs) return []
  const res = []
  for (let index = 0; index < secs.length; index++) {
    const element = secs[index];
    const progress = element.courses.reduce((a, b) => { return a + (b.progress || 0) }, 0)

    res.push({
      id: element.section.id,
      name: element.section.name,
      progress: progress / element.courses.length,
      isComplete: element.courses.filter(x => !x.isComplete).length < 1,
      isStarted: element.courses.filter(x => x.isStarted).length > 0
    })
  }

  return res
}

const PlanPayment: React.FC<{
  id: string,
  courseId: string
}> = ({ id, courseId }) => {
  const [viewDetails, setViewDetails] = useState(false)
  const [confirmRemove, setConfirmRemove] = useState(false)
  const [confirmOffer, setConfirmOffer] = useState(false)
  const [remove, { loading: loadingRemove, data: dataRemove, error: errorRemove }] = useMutation<IHealthCoachRemoveHcCourseOutput, IHealthCoachRemoveHcCourseInput>(REMOVE_MOBILE_COURSE_HC, {
    refetchQueries: [{
      query: GET_PAID_MOBILE_COURSE_HC, variables: {
        patientId: id,
        courseId
      }
    }],
    onCompleted: (e => {
      if (e.healthCoachRemoveHcCourse.ok) {
        toast.success('Course removed')
        setConfirmRemove(false)
      } else {
        toast.error('An error occured\nCourse not removed')
        setConfirmRemove(false)
      }
    })
  })
  const [offer, { loading: loadingOffer, data: dataOffer, error: errorOffer }] = useMutation<IHealthCoachOfferHcCourseOutput, IHealthCoachOfferHcCourseInput>(OFFER_MOBILE_COURSE_HC, {
    refetchQueries: [{
      query: GET_PAID_MOBILE_COURSE_HC, variables: {
        patientId: id,
        courseId
      }
    }],
    onCompleted: (e => {
      if (e.healthCoachOfferHcCourse.ok) {
        toast.success('Course offered')
        setConfirmOffer(false)
      } else {
        toast.error('An error occured\nCourse not offered')
        setConfirmOffer(false)
      }
    })
  })
  const { data, loading, error, refetch } = useQuery<IHealthCoachGetPaidMobileCourseHcOutput
    , IHealthCoachGetPaidMobileCourseHcInput>(GET_PAID_MOBILE_COURSE_HC, {
      variables: {
        patientId: id,
        courseId
      }
    })

  if (!!loading) return null

  if (!data || !data.healthCoachGetPaidMobileCourseHc) return null

  if (!data.healthCoachGetPaidMobileCourseHc.price) return (
    <Flex style={{ background: '#f0f0f0', borderRadius: 3, padding: '2px 8px' }}>
      <Text >Free course</Text>
    </Flex>
  )

  return (
    <>

      <Flex onClick={() => setViewDetails(true)} style={{ cursor: 'pointer', background: data.healthCoachGetPaidMobileCourseHc.paid && data.healthCoachGetPaidMobileCourseHc.paid.isActive ? '#ADD4AD' : '#CD9191', borderRadius: 3, padding: '2px 8px' }}>
        <Text color='white' mr={2}>
          {data.healthCoachGetPaidMobileCourseHc.paid && data.healthCoachGetPaidMobileCourseHc.paid.isActive ? 'Course Purchased' : 'Course Not Purchased'}
        </Text>
        <svg width="24" height="24" viewBox="0 0 72 72" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M51.065 43.916V10.979H18.937V60.739H34.999" fill="white" />
          <path d="M43.1671 63.2961C49.3135 63.2961 54.2961 58.3135 54.2961 52.1671C54.2961 46.0207 49.3135 41.0381 43.1671 41.0381C37.0207 41.0381 32.0381 46.0207 32.0381 52.1671C32.0381 58.3135 37.0207 63.2961 43.1671 63.2961Z" fill="#D0CFCE" />
          <path d="M51.065 43.916V10.979H18.937V60.739H34.999M23.667 16.02H32M23.667 24.5H45.667M23.667 28.271H45.667M23.667 32.041H45.667M23.667 35.812H45.667M23.667 39.583H45.667M36.38 43.35H23.67M33.25 47.12H23.67M32.12 50.89H23.67" stroke="black" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
          <path d="M43.1671 63.2961C49.3135 63.2961 54.2961 58.3135 54.2961 52.1671C54.2961 46.0207 49.3135 41.0381 43.1671 41.0381C37.0207 41.0381 32.0381 46.0207 32.0381 52.1671C32.0381 58.3135 37.0207 63.2961 43.1671 63.2961Z" stroke="black" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
          <path d="M51.0651 60.7391L56.5321 66.2061M33.4391 48.4531H46.8751M32.1721 53.8391H46.8751" stroke="black" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
      </Flex>
      <EnhancedModal
        isOpen={!!viewDetails}
        onClose={() => setViewDetails(false)}>
        {data.healthCoachGetPaidMobileCourseHc.paid ? (
          <Flex flexDirection={'column'}>
            <Heading>Purchase details</Heading>

            <Flex mt={4}>
              <Text mr={2} style={{ fontWeight: 300 }}>purchased on:</Text>
              <Text>{data.healthCoachGetPaidMobileCourseHc.paid.createdAt ? moment(data.healthCoachGetPaidMobileCourseHc.paid.createdAt).format('MM/DD/YYYY hh:mma') : ''}</Text>
            </Flex>
            <Flex mt={2}>
              <Text mr={2} style={{ fontWeight: 300 }}>stripe reference:</Text>
              {data.healthCoachGetPaidMobileCourseHc.paid.stripeReference && (
                <a href={`https://dashboard.stripe.com/payments/${data.healthCoachGetPaidMobileCourseHc.paid.stripeReference}`}
                  target='_blank'>
                  <Text>{data.healthCoachGetPaidMobileCourseHc.paid.stripeReference}</Text>
                </a>
              )}
            </Flex>
            <Flex mt={2}>
              <Text mr={2} style={{ fontWeight: 300 }}>amount paid:</Text>
              <Text>{data.healthCoachGetPaidMobileCourseHc.paid.amountPaid ? `$${data.healthCoachGetPaidMobileCourseHc.paid.amountPaid / 100}` : ''}</Text>
            </Flex>
            <Flex mt={2}>
              <Text mr={2} style={{ fontWeight: 300 }}>offered:</Text>
              <Text>{data.healthCoachGetPaidMobileCourseHc.paid.offered ? 'Yes' : 'No'}</Text>
            </Flex>
            {data.healthCoachGetPaidMobileCourseHc.paid.offered && (
              <Flex mt={2}>
                <Text mr={2} style={{ fontWeight: 300 }}>offered by:</Text>
                <Text>{data.healthCoachGetPaidMobileCourseHc.paid.offeredBy}</Text>
              </Flex>
            )}

            <Button
              variant={'danger'}
              style={{ alignSelf: 'flex-start', padding: '4px 8px' }}
              mt={3}
              disabled={!data.healthCoachGetPaidMobileCourseHc.paid.offered}
              onClick={() => setConfirmRemove(true)}>
              Remove
            </Button>
          </Flex>
        ) : (
          <Flex flexDirection={'column'}>
            <Heading textAlign={'center'}>Course not purchased</Heading>

            <Text mr={2} mt={4} textAlign={'center'}>The patient hasn't purchased this course<br />and won't be able to proceed with it.</Text>
            <Box style={{ backgroundColor: 'white', borderRadius: 12, padding: '8px 32px 16px', alignSelf: 'center' }} mt={4}>
              <Heading textAlign={'center'}>${data.healthCoachGetPaidMobileCourseHc.price / 100}</Heading>
            </Box>

            <Button
              variant={'danger'}
              style={{ alignSelf: 'flex-end', padding: '4px 8px' }}
              mt={4}
              onClick={() => setConfirmOffer(true)}>
              Offer for free
            </Button>
          </Flex>
        )}
      </EnhancedModal>

      <EnhancedModal
        isOpen={!!confirmRemove}
        onClose={() => setConfirmRemove(false)}>
        <Flex flexDirection={'column'}>
          <Heading>Confirmation</Heading>

          <Text mr={2} mt={3}>By confirming, you will remove the rights to the user to access the course</Text>

          <Flex style={{ justifyContent: 'space-between' }} mt={4}>
            <Button variant={'danger'} style={{}} disabled={!!loadingRemove} onClick={() => remove({
              variables: {
                courseId,
                patientId: id
              }
            })}>Remove</Button>

            <Button variant={'primary'} disabled={!!loadingRemove} onClick={() => setConfirmRemove(false)}>Cancel</Button>
          </Flex>
        </Flex>
      </EnhancedModal>

      <EnhancedModal
        isOpen={!!confirmOffer}
        onClose={() => setConfirmOffer(false)}>
        <Flex flexDirection={'column'}>
          <Heading>Confirmation</Heading>

          <Text mr={2} mt={3}>By confirming, you grant full access to this course to the user for <span style={{ textDecoration: 'underline' }}>free</span></Text>

          <Flex style={{ justifyContent: 'space-between' }} mt={4}>
            <Button variant={'danger'} style={{}} disabled={!!loadingOffer} onClick={() => offer({
              variables: {
                courseId,
                patientId: id
              }
            })}>Offer</Button>

            <Button variant={'primary'} disabled={!!loadingOffer} onClick={() => setConfirmRemove(false)}>Cancel</Button>
          </Flex>
        </Flex>
      </EnhancedModal>
    </>
  )
}

export const LastCourses: React.FC<ILastCoursesProps> = ({ id, isMinimized, isMobileUser }) => {
  const initialProgram = [{
    label: 'AIP Program',
    value: 'aipProgram'
  }]
  const [isViewEngagement, setIsViewEngagement] = useState(false)
  const [isAssignCustomPlans, setIsAssignCustomPlans] = useState(false)
  const [programs, setPrograms] = useState<IProgram[]>([...initialProgram])
  const [selectedProgram, setSelectedProgram] = useState<IProgram>()
  const [selectedSection, setSelectedSection] = useState<IPresetPlanSummary | undefined>()
  const [selectedAip, setSelectedAip] = useState<ISummary | undefined>()
  const [showPlanVisits, setShowPlanVisits] = useState(false)
  const { data: dataThyroidJourney, loading: loadingThyroidJourney } = useQuery<IGetPatientMobileCoursesOutput, IGetPatientMobileCoursesInput>(GET_PATIENT_MOBILE_COURSES, {
    variables: {
      patientId: id
    },
    onCompleted: e => {
      if (!!isMinimized) return
      if (e && e.providerGetPatientMobileCourses && e.providerGetPatientMobileCourses.byWeek && e.providerGetPatientMobileCourses.byWeek.length > 0) {
        const weeks = weeksSummary(e.providerGetPatientMobileCourses.byWeek)
        setSelectedAip(weeks[0])
      }
    }
  })
  const { data: dataPresetPlans, loading: loadingPresetPlans, error } = useQuery<IGetPresetPlansOutput, IGetPresetPlansInput>(GET_PRESET_PLANS)
  const { data: dataCustomPresetPlans, loading: loadingCustomPresetPlans, error: errorCustoms, refetch: refetchCustomPresets } = useQuery<IGetCustomAssignedPresetPlansOutput, IGetCustomAssignedPresetPlansInput>(GET_CUSTOM_ASSIGNED_PRESET_PLANS, {
    variables: {
      patientId: id
    }
  })

  useEffect(() => {
    if (loadingCustomPresetPlans) return
    if (loadingPresetPlans) return
    const p: IProgram[] = parseStringify(initialProgram)
    if (dataPresetPlans && dataPresetPlans.getThyroidPrograms) {
      for (let index = 0; index < dataPresetPlans.getThyroidPrograms.length; index++) {
        const element = dataPresetPlans.getThyroidPrograms[index];
        if (element.assignedOnly) {
          if (!dataCustomPresetPlans || !dataCustomPresetPlans.getCustomThyroidProgramsAssignedForPatient) continue
          let ind = dataCustomPresetPlans?.getCustomThyroidProgramsAssignedForPatient.findIndex(x => x.programId === element.id)
          if (ind < 0) {
            continue
          }
        }
        p.push({
          label: element.name,
          value: element.id
        })
      }
      setPrograms(p)
    }


  }, [loadingPresetPlans, loadingCustomPresetPlans, dataCustomPresetPlans, dataPresetPlans])

  useEffect(() => {
    setSelectedProgram(programs[0])
  }, [])

  const [getPlanContent, { data, loading }] = useLazyQuery<IGetPresetPlanSummaryOutput, IGetPresetPlanSummaryInput>(GET_THYROID_PROGRAM_SUMMARY, {
    onCompleted: e => {
      if (!!isMinimized) return
      if (e && e.getThyroidProgramSummaryHealthCoach && e.getThyroidProgramSummaryHealthCoach.length > 0) {
        const dets = e.getThyroidProgramSummaryHealthCoach[0]
        setSelectedSection(dets)
      }
    }
  })

  useEffect(() => {
    if (!selectedProgram) return
    if (selectedProgram.value === 'aipProgram') {
      return
    }

    getPlanContent({
      variables: {
        programId: selectedProgram.value,
        userId: id
      }
    })
  }, [selectedProgram])

  return (
    <Flex flexDirection={'column'} flex={1} width={'100%'} overflow={'hidden'}>
      <Flex mb={4}>
        <Select
          isSearchable={false}
          styles={ReactSelectStyles.programsStyles}
          options={programs}
          value={selectedProgram}
          onChange={(option: IProgram | null, actionMeta: ActionMeta<IProgram>) => {
            console.log({ option })
            if (!option) return
            setSelectedProgram(option || programs[0])
            setShowPlanVisits(false)
          }}
          components={{ Option }} />
        {isMinimized ? (
          <>
            <Flex flex={1} flexDirection={'column'}>
              <Flex>
                {!!isMobileUser ? (
                  <>
                    <Button mr={3} p={'4px 12px'} height={'fit-content'} variant={'pink'} onClick={() => {
                      setIsViewEngagement(true)
                    }}>
                      View Engagement
                    </Button>
                    {(dataPresetPlans?.getThyroidPrograms || []).filter(x => !!x.assignedOnly).length > 0 && (
                      <Button p={'4px 12px'} height={'fit-content'} variant={'pink'} onClick={() => {
                        setIsAssignCustomPlans(true)
                      }}>
                        {`Custom Plans${dataCustomPresetPlans && dataCustomPresetPlans.getCustomThyroidProgramsAssignedForPatient ? ` (${dataCustomPresetPlans.getCustomThyroidProgramsAssignedForPatient.length}/${(dataPresetPlans?.getThyroidPrograms || []).filter(x => !!x.assignedOnly).length})` : ''}`}
                      </Button>
                    )}
                  </>
                ) : (<Flex style={{ cursor: 'pointer', background: '#a50000', borderRadius: 3, padding: '2px 8px' }}>
                  <Text color='white' mr={2}>
                    No Mobile User Associated
                  </Text>
                </Flex>)}
              </Flex>
              <Flex mt={3} justifyContent={'center'} alignItems={'center'}>

                {!!selectedProgram && ((selectedProgram.value !== 'aipProgram' && !loading)) && (
                  <>
                    <PlanPayment id={id} courseId={selectedProgram.value} />
                  </>
                )}
                {!!selectedProgram && ((selectedProgram.value === 'aipProgram' && !loadingThyroidJourney)) && (
                  <>
                    <PlanPayment id={id} courseId={'AIP'} />
                  </>
                )}
              </Flex>
            </Flex>
          </>
        ) : (
          <>

            <Flex flex={1} justifyContent={'center'} alignItems={'center'}>
              {!!selectedProgram && ((selectedProgram.value !== 'aipProgram' && !loading)) && (
                <>
                  <PlanPayment id={id} courseId={selectedProgram.value} />
                </>
              )}
              {!!selectedProgram && ((selectedProgram.value === 'aipProgram' && !loadingThyroidJourney)) && (
                <>
                  <PlanPayment id={id} courseId={'AIP'} />
                </>
              )}
            </Flex>
            {!!isMobileUser ? (
              <>
                <Button mr={3} p={'4px 12px'} height={'fit-content'} variant={'pink'} onClick={() => {
                  setIsViewEngagement(true)
                }}>
                  View Engagement
                </Button>
                {(dataPresetPlans?.getThyroidPrograms || []).filter(x => !!x.assignedOnly).length > 0 && (
                  <Button p={'4px 12px'} height={'fit-content'} variant={'pink'} onClick={() => {
                    setIsAssignCustomPlans(true)
                  }}>
                    {`Custom Plans${dataCustomPresetPlans && dataCustomPresetPlans.getCustomThyroidProgramsAssignedForPatient ? ` (${dataCustomPresetPlans.getCustomThyroidProgramsAssignedForPatient.length}/${(dataPresetPlans?.getThyroidPrograms || []).filter(x => !!x.assignedOnly).length})` : ''}`}
                  </Button>
                )}
              </>
            ) : (<Flex style={{ cursor: 'pointer', background: '#a50000', borderRadius: 3, padding: '2px 8px' }}>
              <Text color='white' mr={2}>
                No Mobile User Associated
              </Text>
            </Flex>)}
          </>
        )}
      </Flex>
      {!!selectedProgram && selectedProgram.value !== 'aipProgram' && !!loading && (
        <PleaseWait />
      )}
      {!!selectedProgram && selectedProgram.value === 'aipProgram' && !!loadingThyroidJourney && (
        <PleaseWait />
      )}
      {(!selectedProgram) && (!!loading || !!loadingThyroidJourney) && (
        <PleaseWait />
      )}

      {!!selectedProgram && selectedProgram.value !== 'aipProgram' && !loading && (
        <Flex flexDirection={'column'} flex={1} width='100%' overflowY={'hidden'}>
          {dataCustomPresetPlans &&
            dataCustomPresetPlans.getCustomThyroidProgramsAssignedForPatient &&
            dataCustomPresetPlans.getCustomThyroidProgramsAssignedForPatient.findIndex(x =>
              x.programId === selectedProgram.value) > -1 ? (
            <Flex flexDirection={'column'} ml={4} mb={3}>
              <Text style={{ color: 'rgba(52,79,122,0.6)', fontSize: '12px' }} mb={2}>CUSTOM PLAN</Text>
              <Flex>
                <Text style={{ color: 'rgba(52,79,122,0.6)', fontSize: '12px' }}>Added to patient on:</Text>
                <Text style={{ fontSize: '12px' }} ml={2}>{moment(dataCustomPresetPlans.getCustomThyroidProgramsAssignedForPatient.find(x => x.programId === selectedProgram.value)!.addedOn).format('MM/DD/YYYY hh:mmA')}</Text>
              </Flex>
              <Flex>
                <Text style={{ color: 'rgba(52,79,122,0.6)', fontSize: '12px' }}>Added to patient by:</Text>
                <Text style={{ fontSize: '12px' }} ml={2}>{dataCustomPresetPlans.getCustomThyroidProgramsAssignedForPatient.find(x => x.programId === selectedProgram.value)!.addedBy}</Text>
              </Flex>
              <Flex>
                <Text style={{ color: 'rgba(52,79,122,0.6)', fontSize: '12px' }}>Internal notes:</Text>
                <Text style={{ fontSize: '12px', fontStyle: !dataCustomPresetPlans.getCustomThyroidProgramsAssignedForPatient.find(x => x.programId === selectedProgram.value)!.customNotes ? 'italic' : '' }} ml={2}>{dataCustomPresetPlans.getCustomThyroidProgramsAssignedForPatient.find(x => x.programId === selectedProgram.value)!.customNotes || 'No note added'}</Text>
              </Flex>
            </Flex>
          ) : null}
          <Flex flex={1} width='100%' overflowY={'hidden'}>
            <PresetPlan details={data?.getThyroidProgramSummaryHealthCoach} onSelect={e => {
              setSelectedSection(e)
              setShowPlanVisits(false)
            }} id={id} program={selectedProgram} showVisits={() => {
              setSelectedSection(undefined)
              setShowPlanVisits(true)
            }} />
            {!!selectedSection && !isMinimized && (
              <Flex style={{
                flex: 1,
                overflow: 'hidden',
                background: 'white',
                borderRadius: '20px',
                padding: '12px'
              }}>
                <ListContainer flexDirection={'column'} flex={1} width='100%'>
                  <DetailsProgramProgress plan={selectedSection} id={id} />
                </ListContainer>
              </Flex>
            )}
            {!!showPlanVisits && !isMinimized && (
              <Flex style={{
                flex: 1,
                overflow: 'hidden',
                background: 'white',
                borderRadius: '20px',
                padding: '12px'
              }}>
                <ListContainer flexDirection={'column'} flex={1} width='100%'>
                  <ShowVisits program={selectedProgram} id={id} />
                </ListContainer>
              </Flex>
            )}
          </Flex>
        </Flex>
      )}

      {!!selectedProgram && selectedProgram.value === 'aipProgram' && !loadingThyroidJourney && (
        <Flex flex={1} width='100%' overflowY={'hidden'}>

          <Weeker weeks={dataThyroidJourney?.providerGetPatientMobileCourses.byWeek || []} onSelect={e => {
            setSelectedAip(e)
            setShowPlanVisits(false)
          }} id={id}
            showVisits={() => {
              setSelectedAip(undefined)
              setShowPlanVisits(true)
            }}
          />
          {!!selectedAip && !isMinimized && (
            <Flex style={{
              flex: 1,
              overflow: 'hidden',
              background: 'white',
              borderRadius: '20px',
              padding: '12px'
            }}>
              <ListContainer flexDirection={'column'} flex={1} width='100%'>
                <DetailsCoursesProgressAip id={id} journeyName={selectedAip.journeyName} byWeeks={dataThyroidJourney?.providerGetPatientMobileCourses.byWeek.find(x => x.week === selectedAip.weekNumber)} />
              </ListContainer>
            </Flex>
          )}
          {!!showPlanVisits && !isMinimized && (
            <Flex style={{
              flex: 1,
              overflow: 'hidden',
              background: 'white',
              borderRadius: '20px',
              padding: '12px'
            }}>
              <ListContainer flexDirection={'column'} flex={1} width='100%'>
                <ShowVisits program={{ value: 'AIP', label: 'AIP Program' }} id={id} />
              </ListContainer>
            </Flex>
          )}
        </Flex>
      )}
      {!!isMinimized && !!selectedProgram && selectedProgram.value === 'aipProgram' && selectedAip && !loadingThyroidJourney && (
        <Modal
          isOpen={true}
          onBackgroundClick={() => {
            setSelectedAip(undefined);
          }}
          onEscapeKeydown={() => {
            setSelectedAip(undefined);
          }}
        >
          <SpecialModalBackground
            onClick={() => {
              setSelectedAip(undefined);
            }}
          >
            <Box
              style={{
                margin: '0 auto',
                alignSelf: 'center',
                borderRadius: '20px',
                position: 'relative',
                background: 'linear-gradient(180deg, #BBD4ED 0%, #FDF5F2 100%)',
                padding: '24px',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                flexDirection: 'column',
                maxWidth: '95vw',
                minWidth: 'initial',
                maxHeight: '95vh',
                minHeight: '95vh',
                overflowY: 'hidden',
              }}
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
              }}
            >
              <Wrapper flex={1} flexDirection={'column'} width={'800px'} style={{ overflowY: 'auto' }}>
                <Flex flex={1} width='100%' overflowY={'hidden'}>
                  {!!selectedAip && (
                    <Flex style={{
                      flex: 1,
                      overflow: 'hidden',
                      padding: '12px'
                    }}>
                      <ListContainer flexDirection={'column'} flex={1} width='100%'>
                        <DetailsCoursesProgressAip id={id} journeyName={selectedAip.journeyName} byWeeks={dataThyroidJourney?.providerGetPatientMobileCourses.byWeek.find(x => x.week === selectedAip.weekNumber)} />
                      </ListContainer>
                    </Flex>
                  )}
                </Flex>
              </Wrapper>
            </Box>
          </SpecialModalBackground>
        </Modal>
      )}

      {!!isMinimized && !!showPlanVisits && selectedProgram && (
        <Modal
          isOpen={true}
          onBackgroundClick={() => {
            setShowPlanVisits(false);
          }}
          onEscapeKeydown={() => {
            setShowPlanVisits(false);
          }}
        >
          <SpecialModalBackground
            onClick={() => {
              setShowPlanVisits(false);
            }}
          >
            <Box
              style={{
                margin: '0 auto',
                alignSelf: 'center',
                borderRadius: '20px',
                position: 'relative',
                background: 'linear-gradient(180deg, #BBD4ED 0%, #FDF5F2 100%)',
                padding: '24px',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                flexDirection: 'column',
                maxWidth: '95vw',
                minWidth: 'initial',
                maxHeight: '95vh',
                minHeight: '95vh',
                overflowY: 'hidden',
              }}
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
              }}
            >
              <Wrapper flex={1} flexDirection={'column'} width={'800px'} style={{ overflowY: 'auto' }}>
                <Flex flex={1} width='100%' overflowY={'hidden'}>
                  {!!showPlanVisits && (
                    <Flex style={{
                      flex: 1,
                      overflow: 'hidden',
                      padding: '12px'
                    }}>
                      <ListContainer flexDirection={'column'} flex={1} width='100%'>
                        <ShowVisits program={{ value: selectedProgram.value === 'aipProgram' ? 'AIP' : selectedProgram.value, label: selectedProgram.value === 'aipProgram' ? 'AIP Program' : selectedProgram.label }} id={id} />
                      </ListContainer>
                    </Flex>
                  )}
                </Flex>
              </Wrapper>
            </Box>
          </SpecialModalBackground>
        </Modal>
      )}
      {!!isMinimized && !!selectedProgram && selectedProgram.value !== 'aipProgram' && selectedSection && !loading && (
        <Modal
          isOpen={true}
          onBackgroundClick={() => {
            setSelectedSection(undefined);
          }}
          onEscapeKeydown={() => {
            setSelectedSection(undefined);
          }}
        >
          <SpecialModalBackground
            onClick={() => {
              setSelectedSection(undefined);
            }}
          >
            <Box
              style={{
                margin: '0 auto',
                alignSelf: 'center',
                borderRadius: '20px',
                position: 'relative',
                background: 'linear-gradient(180deg, #BBD4ED 0%, #FDF5F2 100%)',
                padding: '24px',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                flexDirection: 'column',
                maxWidth: '95vw',
                minWidth: 'initial',
                maxHeight: '95vh',
                minHeight: '95vh',
                overflowY: 'hidden',
              }}
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
              }}
            >
              <Wrapper flex={1} flexDirection={'column'} width={'800px'} style={{ overflowY: 'auto' }}>
                <Flex flex={1} width='100%' overflowY={'hidden'}>
                  {!!selectedSection && (
                    <Flex style={{
                      flex: 1,
                      overflow: 'hidden',
                      padding: '12px'
                    }}>
                      <ListContainer flexDirection={'column'} flex={1} width='100%'>
                        <DetailsProgramProgress id={id} plan={selectedSection} />
                      </ListContainer>
                    </Flex>
                  )}
                </Flex>
              </Wrapper>
            </Box>
          </SpecialModalBackground>
        </Modal>
      )}
      {!!isAssignCustomPlans && dataPresetPlans && dataPresetPlans.getThyroidPrograms && dataCustomPresetPlans && dataCustomPresetPlans.getCustomThyroidProgramsAssignedForPatient && (
        <Modal
          isOpen={true}
          onBackgroundClick={() => {
            setIsAssignCustomPlans(false);
          }}
          onEscapeKeydown={() => {
            setIsAssignCustomPlans(false);
          }}
        >
          <SpecialModalBackground
            onClick={() => {
              setIsAssignCustomPlans(false);
            }}
          >
            <Box
              style={{
                margin: '0 auto',
                alignSelf: 'center',
                borderRadius: '20px',
                position: 'relative',
                background: 'linear-gradient(180deg, #BBD4ED 0%, #FDF5F2 100%)',
                padding: '24px',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                flexDirection: 'column',
                maxWidth: '95vw',
                minWidth: 'initial',
                maxHeight: '95vh',
                minHeight: '95vh',
                overflowY: 'hidden',
              }}
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
              }}
            >
              <Wrapper flex={1} flexDirection={'column'} width={'800px'} style={{ overflowY: 'auto' }}>
                <Flex flex={1} width='100%' overflowY={'hidden'}>
                  <AssignCustomPresetPlans
                    patientId={id}
                    presetPlans={dataPresetPlans.getThyroidPrograms}
                    customAssigned={dataCustomPresetPlans.getCustomThyroidProgramsAssignedForPatient} />
                </Flex>
              </Wrapper>
            </Box>
          </SpecialModalBackground>
        </Modal>
      )}
      {!!isViewEngagement && selectedProgram && (
        <Modal
          isOpen={true}
          onBackgroundClick={() => {
            setIsViewEngagement(false);
          }}
          onEscapeKeydown={() => {
            setIsViewEngagement(false);
          }}
        >
          <SpecialModalBackground
            onClick={() => {
              setIsViewEngagement(false);
            }}
          >
            <Box
              style={{
                margin: '0 auto',
                alignSelf: 'center',
                borderRadius: '20px',
                position: 'relative',
                background: 'linear-gradient(180deg, #BBD4ED 0%, #FDF5F2 100%)',
                padding: '24px',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                flexDirection: 'column',
                maxWidth: '95vw',
                minWidth: 'initial',
                maxHeight: '450px',
                minHeight: '450px',
                overflowY: 'hidden',
              }}
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
              }}
            >
              <Wrapper flex={1} flexDirection={'column'} width={'800px'} style={{ overflowY: 'auto' }}>
                <Flex flex={1} width='100%' overflowY={'hidden'} height={'400px'}>
                  <CourseEngagementChart
                    patientId={id}
                    close={() => {
                      setIsViewEngagement(false);
                    }}
                    programId={selectedProgram.value}
                  />
                </Flex>
              </Wrapper>
            </Box>
          </SpecialModalBackground>
        </Modal>
      )}
    </Flex>
  )
}